import { AssistantBriefing } from '@speles7172/assistant-console';
import '@speles7172/assistant-console/styles.css';
import { assistantTransport } from '../../api/assistant';
import { useAssistantNavigation } from './useAssistantNavigation';

/**
 * The assistant's start-of-day card on the producer dashboard: what needs
 * attention today, from events, tasks and conversations, with a suggested
 * action or two. The package's component whole, inside `.peles-controls` so it
 * takes the app's palette (`styles/controls-bridge.css`), on `theme="light"`
 * because the bridge, not the operating system, follows the app's dark mode.
 */
export function AssistantBriefingCard({ className = '' }: { className?: string }) {
  const { onOpen, onActionDone, language, setLanguage } = useAssistantNavigation();
  return (
    <div className={`peles-controls ${className}`}>
      <AssistantBriefing
        transport={assistantTransport}
        onOpen={onOpen}
        onActionDone={onActionDone}
        language={language}
        onLanguageChange={setLanguage}
        theme="light"
      />
    </div>
  );
}
